export default "__VITE_ASSET__DqTvBK1N__"